// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientConsentPreview_root__1AuEM","description":"PatientConsentPreview_description__3GuIk"};